import React, { Component } from 'react';

import './index.css';

export default class UnderlineText extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 0
    };

    this.handleResize = this.handleResize.bind(this);
    // this.handleMouseEnter = this.handleMouseEnter.bind(this);
    // this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  // spanifyTextElement() {
  //   const { text } = this.props;
  //   const spanInserted = text.split(" ").join(" </span><span>");
  //   this.text.innerHTML = ("<span>").concat(spanInserted, "</span>");
  //   let refPos = this.text.querySelector('span:first-child').getBoundingClientRect().top;
  //   const spans = this.text.querySelectorAll('span');
  //   let newPos;
  //   spans.forEach((span, index) => {
  //     if (index === 0) return;
  //     newPos = span.getBoundingClientRect().top;
  //     if (newPos == refPos) {
  //       const prev = span.previousElementSibling;
  //       const underline = document.createElement('div');
  //       underline.className = 'underline';
  //       span.prepend(prev.textContent + " ");
  //       span.prepend(underline);
  //       // span.append('');
  //       span.parentNode.removeChild(prev);
  //     } 
  //     refPos = newPos;
  //   });

  //   console.log(this.text);
  // }

  handleResize() {
    if (this.text) {
      // console.log(this.text, this.text.getBoundingClientRect().width);
      //  if (this.props.spanify) this.spanifyTextElement();
      const width = this.text.getBoundingClientRect().width;
      if (width < 1) setTimeout(this.handleResize, 300);
      this.setState(() => ({ width }));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) this.handleResize();
  }

  componentWillUnmount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentDidMount() {
    setTimeout(() => this.handleResize(), 500);
    window.addEventListener('resize', this.handleResize);
  }
  

  render() {
    const { text, colour, className, onAnimationStart } = this.props;
    const { width } = this.state;
    // const children = text.split(/\n/g);

    return (
      <div className={`underlined-text ${className}`} onAnimationStart={onAnimationStart ? onAnimationStart.bind(this) : null} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
        <span className="text" ref={instance => this.text = instance}>{text}</span>
        <div className="underline" style={{ backgroundColor: colour, width}} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnderlinedText/index.js